require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-author-lizzie-tao.json") })
        }
      }, "path---blog-author-lizzie-tao");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-author-lizzie-tao!./.cache/json/blog-author-lizzie-tao.json
// module id = 671
// module chunks = 231608221292675